export function pattern_capsule({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <filter id="blend_gaps_${compId}">
    <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 6 -3" result="blend_gaps_${compId}" />
    <feBlend in="SourceGraphic" in2="blend_gaps_${compId}" />
  </filter>
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
<g filter="url(#blend_gaps_${compId})">
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 120;0 200;0 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 100;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.5 * animationSpeed}s"
      dur="${5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="120 120;120 200;120 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${5.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="120 0;120 100;120 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.5 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="240 120;240 200;240 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2 * animationSpeed}s"
      dur="${5.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="240 0;240 100;240 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.5 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="360 120;360 200;360 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="360 0;360 100;360 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3.5 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="480 120;480 200;480 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-4 * animationSpeed}s"
      dur="${5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="480 0;480 100;480 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-4.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="600 120;600 200;600 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-5 * animationSpeed}s"
      dur="${4.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="600 0;600 100;600 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-5.5 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="720 120;720 200;720 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-6 * animationSpeed}s"
      dur="${5.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="720 0;720 100;720 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-6.5 * animationSpeed}s"
      dur="${7 * animationSpeed}s" repeatCount="indefinite"/>
    </path>

    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="840 120;840 200;840 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-7 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="840 0;840 100;840 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-7.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 120;960 200;960 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-8 * animationSpeed}s"
      dur="${4.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 100;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-8.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1080 120;1080 200;1080 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-9 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1080 0;1080 100;1080 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-9.5 * animationSpeed}s"
      dur="${5.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1200 120;1200 200;1200 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-10 * animationSpeed}s"
      dur="${4.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1200 0;1200 100;1200 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-10.5 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1320 120;1320 200;1320 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-11 * animationSpeed}s"
      dur="${7 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1320 0;1320 100;1320 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-11.5 * animationSpeed}s"
      dur="${5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1440 120;1440 200;1440 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-12 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1440 0;1440 100;1440 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-12.5 * animationSpeed}s"
      dur="${5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1560 120;1560 200;1560 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-13 * animationSpeed}s"
      dur="${4.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1560 0;1560 100;1560 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-13.5 * animationSpeed}s"
      dur="${7 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1680 120;1680 200;1680 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-14 * animationSpeed}s"
      dur="${6.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1680 0;1680 100;1680 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-14.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M61,0v240H-1L-1,0C-1,16.5,13,30,30,30S61,16.5,61,0z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1800 120;1800 200;1800 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-15 * animationSpeed}s"
      dur="${5.5 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path d="M121,35.6C121,16,107.1,0,90,0S59,16,59,35.6V240h62V35.6z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1800 0;1800 100;1800 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-15.5 * animationSpeed}s"
      dur="${7 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
</g>

  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}